<template>
    <div class="myprogress">
        <div class="courselist" v-for="(item,index) in c_infolist" :key="item.id">
            <div :class="['course',{'hasprogress':item.x_progress.remainseconds>0 && !issmall}]">
                <div class="title">
                    <router-link class="overparent" :to="item.x_root+item.id" :title="$common.langinfo(item.title,item.title_en)"><ffoverdot :title="item.title" :title_en="item.title_en" :needtitle="true"></ffoverdot></router-link>
                    <template v-if="item.x_progress.remainseconds>0 && issmall">
                        ({{item.x_progress.x_remaintime}})
                    </template>
                </div>
                <div class="bar" @click="showtopic(index)">
                    <div class="line">
                        <div class="now" :style="{width:item.x_progress.perc+'%'}">
                            <div v-if="item.x_progress.remainseconds>0 && !issmall" class="end">
                                <router-link v-if="item.x_progress.perc==100" :to="item.x_root+item.id">{{$common.dicword('lastlearning')}}<br>{{$common.basic.dateformat(item.x_progress.timeend,'yyyy-MM-dd hh:mm')}}</router-link>
                                <router-link v-else :to="item.x_root+'continue/'+item.id">{{$common.dicword('lastlearning')}}<br>{{$common.basic.dateformat(item.x_progress.timeend,'yyyy-MM-dd hh:mm')}}</router-link>

                                <span class="arrow"></span>
                            </div>
                        </div>
                    </div>
                    <div v-if="item.x_progress.remainseconds>0 && !issmall" class="start">{{$common.dicword('startlearning')}}<br>{{$common.basic.dateformat(item.x_progress.timebegin,'yyyy-MM-dd hh:mm')}}</div>
                </div>
                <div class="time" v-if="!issmall">{{item.x_progress.x_remaintime}}</div>

            </div>
            <transition name="slidedown">
                <div v-if="item.x_isopen" class="topiclisttran">
                    <div class="topiclist">
                        <div class="topicwrap" v-for="(item2,index2) in item.x_children" :key="item2.id">
                            <div class="topic" @click="showlesson(index2,index)">
                                <dl>
                                    <dd class="a"><router-link class="overparent" :to="item.x_root+item.id+'/'+item2.id" :title="$common.langinfo(item2.title,item2.title_en)"><ffoverdot :title="item2.title" :title_en="item2.title_en" :needtitle="true"></ffoverdot></router-link></dd>
                                    <dd class="b">{{item2.x_learntime}}</dd>
                                    <dd class="c">
                                        <span class="circle">
                                            <span v-if="item2.x_perc==0" class="ready"></span>
                                            <span v-else-if="item2.x_perc==100" class="done"></span>
                                            <template v-else>
                                                <span class="doing" :style="{transform: 'rotate('+(item2.x_perc*3.6)+'deg)'}"></span>
                                                <span :class="[item2.x_perc<=50?'fanless':'fanmore']"></span>
                                            </template>
                                        </span>
                                    </dd>
                                </dl>
                            </div>
                            <transition name="slidedown">
                                <div v-if="item2.x_isopen" class="lessonlisttran">
                                    <div class="lessonlist" v-if="item.x_ispmp">
                                        <div class="lessonwrap" v-for="(item3,index3) in item2.x_children" :key="item3.id">
                                            <div class="lesson" @click="showpage(index3,index2,index)">
                                                <dl>
                                                    <dd class="a"><router-link class="overparent" :to="item.x_root+item.id+'/'+item3.id" :title="$common.langinfo(item3.title,item3.title_en)"><ffoverdot :title="item3.title" :title_en="item3.title_en" :needtitle="false"></ffoverdot></router-link></dd>
                                                    <dd class="b">{{item3.x_learntime}}</dd>
                                                    <dd class="c">
                                                        <span v-if="item3.courseinfotypekv==666">{{item3.x_quizscore}}</span>
                                                        <span class="circle" v-else>

                                                            <span v-if="item3.x_perc==0" class="ready"></span>
                                                            <span v-else-if="item3.x_perc==100" class="done"></span>
                                                            <template v-else>
                                                                <span class="doing" :style="{transform: 'rotate('+(item3.x_perc*3.6)+'deg)'}"></span>
                                                                <span :class="[item3.x_perc<=50?'fanless':'fanmore']"></span>
                                                            </template>
                                                        </span>
                                                    </dd>
                                                </dl>
                                            </div>
                                            <transition name="slidedown">
                                                <div v-if="item3.x_isopen" class="pagelisttran">
                                                    <div class="pagelist" v-for="item4 in item3.x_children" :key="item4.id">
                                                        <dl>
                                                            <dd class="a"><router-link :to="item.x_root+item.id+'/'+item4.id" :title="$common.langinfo(item4.title,item4.title_en)"><ffoverdot class="overparent" :title="item4.title" :title_en="item4.title_en" :needtitle="false"></ffoverdot></router-link></dd>
                                                            <dd class="b">{{item4.x_learntime}}</dd>
                                                            <dd class="c">
                                                                <span v-if="item4.courseinfotypekv==666">{{item4.x_quizscore}}</span>
                                                                <span class="circle" v-else>
                                                                    <span v-if="item4.x_perc==0" class="ready"></span>
                                                                    <span v-else-if="item4.x_perc==100" class="done"></span>
                                                                    <template v-else>
                                                                        <span class="doing" :style="{transform: 'rotate('+(item4.x_perc*3.6)+'deg)'}"></span>
                                                                        <span :class="[item4.x_perc<=50?'fanless':'fanmore']"></span>
                                                                    </template>
                                                                </span>

                                                            </dd>
                                                        </dl>
                                                    </div>
                                                </div>
                                            </transition>
                                        </div>

                                    </div>
                                    <template v-else>
                                        <div class="lessonlist" v-for="item3 in item2.x_children" :key="item3.id">
                                            <dl>
                                                <dd class="a"><router-link class="overparent" :to="item.x_root+item.id+'/'+item3.id" :title="$common.langinfo(item3.title,item3.title_en)"><ffoverdot :title="item3.title" :title_en="item3.title_en" :needtitle="false"></ffoverdot></router-link></dd>
                                                <dd class="b">{{item3.isquiz==0?item3.x_learntime:item3.x_quizscorelist}}</dd>
                                                <dd class="c">

                                                    <span class="circle" v-if="item3.isquiz==0">
                                                        <span v-if="item3.x_perc==0" class="ready"></span>
                                                        <span v-else-if="item3.x_perc==100" class="done"></span>
                                                        <template v-else>
                                                            <span class="doing" :style="{transform: 'rotate('+(item3.x_perc*3.6)+'deg)'}"></span>
                                                            <span :class="[item3.x_perc<=50?'fanless':'fanmore']"></span>
                                                        </template>
                                                    </span>
                                                    <span v-else>{{item3.x_quizscore}}</span>
                                                </dd>
                                            </dl>
                                        </div>
                                    </template>

                                </div>
                            </transition>
                        </div>
                    </div>
                </div>
            </transition>
        </div>

        <div class="memnorecord" v-if="c_infolist.length==0 && isload">{{$common.dicword('norecord')}}</div>
    </div>

</template>

<script>
    import { mixinsubpage } from "@/mixin/mixin"

    export default {
        name: 'Cprogress',
        mixins: [mixinsubpage],
        data() {
            return {
                postact: 'tc_my_progress'
            };
        },
        methods: {
            getdata: function () {
                this.$common.post(this.postjson, res => {
                    this.isload = true;
                    this.$common.each(res.infodataprogress, (item) => {
                        item.x_remaintime = this.$common.basic.chint2time(Math.round(item.remainseconds / 60));
                    });

                    this.$common.each(res.infodatacourse, (item) => {
                        item.x_progress = this.$common.basic.fffind((res.infodataprogress || []), 'courseid', item.realid);
                        item.x_isload = false;
                        item.x_isopen = false;
                        item.x_ispmp = item.realtypekv == this.$common.CTVIDEO;
                        item.x_root = this.$common.tranlearnfolder(item.realtypekv);
                    });
                    this.infolist = res.infodatacourse;
                });
            },
            showtopic: function (v) {

                if (!this.infolist[v].x_isload) {
                    let jsondata = { 'postdata': { 'act': 'tc_my_progress_topic', 'id': this.infolist[v].realid, 'data': { 'stuid': this.stuid } }, 'msg': '' };
                    this.$common.post(jsondata, res => {
                        this.$common.each(res.infodata, (item) => {

                            item.x_isload = false;
                            item.x_isopen = false;
                            item.x_learntime = '';
                            item.x_perc = 0;
                            let pro = this.$common.basic.fffind((res.infodataprogress || []), 'topicid', item.id);
                            if (this.$common.basic.isobjexist(pro)) {
                                item.x_perc = pro.perc;
                                item.x_learntime = this.$common.basic.dateformat(pro.timebegin, 'yyyy-MM-dd hh:mm') + '/' + this.$common.basic.dateformat(pro.timeend, 'yyyy-MM-dd hh:mm')
                            }

                        });
                        this.$set(this.infolist[v], 'x_children', res.infodata);
                        this.infolist[v].x_isopen = !this.infolist[v].x_isopen;
                        this.infolist[v].x_isload = true;
                    });
                }
                else {
                    this.infolist[v].x_isopen = !this.infolist[v].x_isopen;
                }

            },
            showlesson(v, courseindex) {
                if (!this.infolist[courseindex].x_children[v].x_isload) {
                    let jsondata = { 'postdata': { 'act': 'tc_my_progress_lesson', 'id': this.infolist[courseindex].realid, 'data': { 'stuid': this.stuid, 'topicid': this.infolist[courseindex].x_children[v].id } }, 'msg': '' };//id应为realid
                    //let jsondata = { 'postdata': { 'act': 'tc_my_progress_lesson', 'id': this.infolist[courseindex].id, 'data': { 'stuid': this.stuid, 'topicid': this.infolist[courseindex].x_children[v].id } }, 'msg': '' };//id应为realid
                    this.$common.post(jsondata, res => {
                        this.$common.each(res.infodata, (item) => {
                            item.x_learntime = '';
                            item.x_perc = 0;
                            let pro = this.$common.basic.fffind((res.infodataprogress || []), 'lessonid', item.id);
                            if (this.$common.basic.isobjexist(pro)) {
                                item.x_perc = pro.perc;
                                item.x_quizscore = 0;
                                item.x_quizscorelist = "";
                                //if (this.infolist[courseindex].leveltypekv == this.$common.telev) {
                                if (this.infolist[courseindex].typekv == this.$common.telev) {
                                    item.x_perc = pro.iscompleted == 1 ? 100 : 25;
                                    if (this.infolist[courseindex].x_children[v].isquiz == 1) {
                                        item.x_quizscore = pro.quizscore;
                                        item.x_quizscorelist = pro.quizscorelist
                                    }
                                }

                                item.x_learntime = this.$common.basic.dateformat(pro.timebegin, 'yyyy-MM-dd hh:mm') + '/' + this.$common.basic.dateformat(pro.timeend, 'yyyy-MM-dd hh:mm')
                            }
                        });
                        this.$set(this.infolist[courseindex].x_children[v], 'x_children', res.infodata);
                        this.infolist[courseindex].x_children[v].x_isopen = !this.infolist[courseindex].x_children[v].x_isopen;
                        this.infolist[courseindex].x_children[v].x_isload = true;
                    });
                }
                else {
                    this.infolist[courseindex].x_children[v].x_isopen = !this.infolist[courseindex].x_children[v].x_isopen;
                }

            },
            showpage(v, topicindex, courseindex) {
                let itemlesson = this.infolist[courseindex].x_children[topicindex].x_children[v];
                if (!itemlesson.x_isload) {
                    let jsondata = { 'postdata': { 'act': 'tc_my_progress_page', 'id': this.infolist[courseindex].realid, 'data': { 'stuid': this.stuid, 'lessonid': itemlesson.id, 'topicid': this.infolist[courseindex].x_children[topicindex].id } }, 'msg': '' };
                    this.$common.post(jsondata, res => {
                        this.$common.each(res.infodata, (item) => {
                            item.x_learntime = '';
                            item.x_perc = 0;
                            let pro = this.$common.basic.fffind((res.infodataprogress || []), 'pageid', item.id);
                            if (this.$common.basic.isobjexist(pro)) {
                                item.x_perc = pro.perc;
                                item.x_quizscore = pro.quizscore;
                                item.x_quizscorelist = "";

                                item.x_learntime = this.$common.basic.dateformat(pro.timebegin, 'yyyy-MM-dd hh:mm') + '/' + this.$common.basic.dateformat(pro.timeend, 'yyyy-MM-dd hh:mm')
                            }
                        });
                        this.$set(itemlesson, 'x_children', res.infodata);
                        itemlesson.x_isopen = !itemlesson.x_isopen;
                        itemlesson.x_isload = true;
                    });
                }
                else {
                    itemlesson.x_isopen = !itemlesson.x_isopen;
                }

            }
        }
    }
</script>
